import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CalendarButtonComponent } from "./calendar-button.component";
import { IonicModule } from "ionic-angular";

@NgModule({
    imports: [
        CommonModule,
        IonicModule
    ],
    declarations: [
        CalendarButtonComponent
    ],
    exports: [
        CalendarButtonComponent
    ]
})
export class CalendarButtonModule {
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/calendar-button/calendar-button.module.ts